import axios from 'axios'
import _ from 'lodash'
import store from '@/store'

const activeRequestConfigs = []
const activeCancelableRequests = {}

axios.interceptors.request.use(config => {
  const calcellationKey = _.get(config, 'cancelToken.reason.message')
  if(calcellationKey) {
    activeCancelableRequests[calcellationKey] = config
  }
  onRequest(config)
  return config
}, error => {
  onRequest(error.request)
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  onResponse(response)
  return response
}, (error) => {
  if(axios.isCancel(error)) {
    removeActiveRequestConfig({ config: activeCancelableRequests[error.message] })
  } else {
    onResponse(error.response)
  }
  return Promise.reject(error)
})

function onRequest(config) {
  addActiveRequestConfig(config)
}

function onResponse(response) {
  removeActiveRequestConfig(response)
  handleNotifications(response)
}

function addActiveRequestConfig(config) {
  activeRequestConfigs.push(config)
  store.dispatch('ui/updateActiveXhrConfigs', activeRequestConfigs)
}

function removeActiveRequestConfig(response) {
  const index = _.findIndex(activeRequestConfigs, config => config === response.config)
  activeRequestConfigs.splice(index, 1)
  store.dispatch('ui/updateActiveXhrConfigs', activeRequestConfigs)
}

function handleNotifications(response) {
  const notifications = getPayloadNotifications(response)
  if(!_.some(notifications)) { return }
  const notificationsList = [...notifications]

  _.forEach(notificationsList, notification => {
    store.dispatch('ui/addNotification', notification)
  })
}

function getPayloadNotifications(response) {
  if(response.data && response.data.hasOwnProperty('notifications') && response.data.data) {
    const notifications = response.data.notifications
    response.data = response.data.data
    return notifications
  }
  return []
}
